import React, { createContext, useContext, useEffect, useReducer } from 'react';

import { generateNumericId } from './utils/generate-random-number.utils';

const CartContext = createContext();

const cartReducer = (state, action) => {
  function deepEqual(obj1, obj2) {
    if (obj1 === obj2) {
      return true;
    }

    if (
      typeof obj1 !== 'object' ||
      typeof obj2 !== 'object' ||
      obj1 === null ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1).filter(
      (key) => key !== 'quantity' && key !== 'cust_id'
    );
    const keys2 = Object.keys(obj2).filter(
      (key) => key !== 'quantity' && key !== 'cust_id'
    );

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  switch (action.type) {
    case 'ADD_ITEM':
      const existingItemIndex = state.items.findIndex(
        (item) => item.id === action.payload.id
      );

      if (existingItemIndex >= 0) {
        const existingItem = state.items[existingItemIndex];

        // Perform a deep equality check to compare the entire object
        if (deepEqual(existingItem, action.payload)) {
          const newItems = [...state.items];
          newItems[existingItemIndex] = {
            ...newItems[existingItemIndex],
            quantity: newItems[existingItemIndex].quantity + 1,
          };
          return { ...state, items: newItems };
        }
      }

      return {
        ...state,
        items: [
          ...state.items,
          action.payload.title === 'Tortilla Tacos' ||
          action.payload.title === 'Bowl'
            ? { ...action.payload, quantity: 1, cust_id: generateNumericId() }
            : { ...action.payload, quantity: 1 },
        ],
      };

    case 'REMOVE_ITEM':
      return {
        ...state,
        items: state.items.filter((item) => {
          if (action.payload.cust_id) {
            return !(
              item.id === action.payload.id &&
              item.cust_id === action.payload.cust_id
            );
          }
          return item.id !== action.payload.id;
        }),
      };

    case 'UPDATE_QUANTITY':
      return {
        ...state,
        items: state.items
          .map((item) => {
            if (
              ((action.payload.id === 'Bowl' ||
                action.payload.id === 'Tortilla Tacos') &&
                item.cust_id === action.payload.cust_id) ||
              (item.cust_id === undefined && item.id === action.payload.id)
            ) {
              return { ...item, quantity: action.payload.quantity };
            }
            return item;
          })
          .filter((item) => item.quantity > 0),
      };

    case 'CLEAR_CART':
      return { ...state, items: [] };

    default:
      return state;
  }
};

export const CartProvider = ({ children }) => {
  const initialCartState = JSON.parse(localStorage.getItem('cart')) || {
    items: [],
  };

  const [state, dispatch] = useReducer(cartReducer, initialCartState);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(state));
  }, [state]);

  return (
    <CartContext.Provider value={{ state, dispatch }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};
